import { AW } from '@airwallet/types';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class ActionCardService {
    constructor(private translate: TranslateService) {}

    getTitle(actionLog: AW.Operator.Action.ActionLog, isForLog: boolean, isSkeleton: boolean, action?: AW.Operator.Action.Action): string {
        let title = this.translate.instant(`operator.actions.titles.${actionLog.action_type}`);

        if (this.checkIfBasicAction(actionLog)) {
            if (actionLog.state === 'complete') {
                title = this.translate.instant(`operator.actions.completed_titles.${actionLog.action_type}`);
            }
        }

        if (actionLog.action_type === 'location_remove_machine') {
            title = title + ` ${this.translate.instant(`misc.${actionLog.action!.product_type!.toLowerCase()}`).toLowerCase()}`;
        }

        if (actionLog.action_type === 'machine_maintenance_due' || actionLog.action_type === 'out_of_bleach' || actionLog.action_type === 'out_of_detergent' || actionLog.action_type === 'out_of_softener') {
            if ('device_name' in action!.statics) {
                title = title + ` ${action!.statics.device_name}`;
            }
        }

        if ((actionLog.action_type === 'out_of_bleach' || actionLog.action_type === 'out_of_detergent' || actionLog.action_type === 'out_of_softener') && actionLog.state !== 'complete') {
            if ('device_name' in action!.statics) {
                title = this.translate.instant(`operator.actions.titles.${actionLog.action_type}_${actionLog.state}`) + ` ${action!.statics.device_name}`;
            }
        }

        if (isForLog) {
            if (actionLog.closed === 'closed_by_user') {
                return `${title} - ${this.translate.instant('operator.actions.closed_by_user')} ${actionLog.user_name ? actionLog.user_name : this.translate.instant('operator.actions.user')}`;
            } else if (actionLog.closed === 'unclosed_by_user') {
                return (
                    title +
                    `- ${this.translate.instant('operator.actions.unclosed_by_user_1')}` +
                    ` ${actionLog.state}` +
                    ` ${this.translate.instant('operator.actions.unclosed_by_user_2')}` +
                    ` ${actionLog.user_name ? actionLog.user_name : this.translate.instant('operator.actions.user')}`
                );
            }
        } else {
            if (actionLog.action_type === 'anton_low_battery' && actionLog.state !== 'complete' && !isSkeleton) {
                title = title + `: ${Math.round(action!.dynamics!.battery_status! * 100)}%`;
            }
        }
        return title;
    }

    checkIfBasicAction(actionLog: AW.Operator.Action.ActionLog): boolean {
        return (
            actionLog.action_type === 'anton_offline' ||
            actionLog.action_type === 'anton_low_battery' ||
            actionLog.action_type === 'unit_not_used' ||
            actionLog.action_type === 'unit_used_less' ||
            actionLog.action_type === 'out_of_bleach' ||
            actionLog.action_type === 'machine_maintenance_due' ||
            actionLog.action_type === 'out_of_detergent' ||
            actionLog.action_type === 'out_of_softener'
        );
    }

    getDescription(actionLog: AW.Operator.Action.ActionLog, action: AW.Operator.Action.Action): string {
        if (actionLog.state === 'complete') {
            return this.translate.instant(`operator.actions.completed_descriptions.${actionLog.action_type}`);
        }
        switch (actionLog.action_type) {
            case 'unit_not_used': {
                moment.duration(moment().diff(moment(actionLog.action!.last_used))).asDays();
                return `
                    ${this.translate.instant('operator.actions.descriptions.not_used_descrip_1')}
                    ${Math.floor((moment().unix() - actionLog.action!.last_used!) / 86400)}
                    ${this.translate.instant('operator.actions.descriptions.not_used_descrip_2')}
                    `;
            }
            case 'location_remove_machine': {
                return `
                    ${this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_1`)}
                    ${this.translate.instant(`operator.actions.${actionLog.action!.product_type!.toLowerCase()}`)}.
                    ${this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_2`)}
                    `;
            }
            case 'out_of_bleach': {
                if (actionLog.state === 'observing') {
                    return `${action.dynamics!.current_bleach_count}/${action.dynamics!.bleach_limit} ${this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_${actionLog.state}`)}`;
                } else {
                    return this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_${actionLog.state}`);
                }
            }
            case 'out_of_detergent': {
                if (actionLog.state === 'observing') {
                    return `${action.dynamics!.current_detergent_count}/${action.dynamics!.detergent_limit} ${this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_${actionLog.state}`)}`;
                } else {
                    return this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_${actionLog.state}`);
                }
            }
            case 'out_of_softener': {
                if (actionLog.state === 'observing') {
                    return `${action.dynamics!.current_softener_count}/${action.dynamics!.softener_limit} ${this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_${actionLog.state}`)}`;
                } else {
                    return this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_${actionLog.state}`);
                }
            }
            case 'machine_maintenance_due': {
                return `
                    ${this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_1`)}
                    ${action.dynamics!.current_maintenance_count}
                    ${this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}_2`)}
                    `;
            }
            default: {
                return this.translate.instant(`operator.actions.descriptions.${actionLog.action_type}`);
            }
        }
    }
}
